import { Action, Dispatch } from 'redux';
import { get } from 'components/Shared/server';
import { ConservatoryAddonProductModel } from 'models/ConservatoryAddonProductModel';

const RESPONSESTATUS_SUCCESS = 200;

export const GUIDE_ADDONS_DATA_LOADING = 'GUIDE_ADDONS_DATA_LOADING';
export const GUIDE_ADDONS_DATA_LOADED = 'GUIDE_ADDONS_DATA_LOADED';
export const GUIDE_ADDONS_SELECT_PRODUCT = 'GUIDE_ADDONS_SELECT_PRODUCT';

export interface ConservatoryAddonsAction extends Action {
  products: ConservatoryAddonProductModel[];
}

export interface ConservatoryAddonsSelectAction extends Action {
  productId: string;
}

export const guideAddonsSelectProduct = (productId: string) => ({
  type: GUIDE_ADDONS_SELECT_PRODUCT,
  productId
});

export const guideAddonsDataloaded = (
  addonProducts?: ConservatoryAddonProductModel[] | undefined
) => ({
  type: GUIDE_ADDONS_DATA_LOADED,
  products: addonProducts
});

export const guideAddonsDataloading = () => ({
  type: GUIDE_ADDONS_DATA_LOADING,
  products: undefined
});

export const guideAddonsFetchData = (dispatch: Dispatch) => {
  return (productId: string) => {
    dispatch(guideAddonsDataloading());

    if (productId.length < 1) {
      dispatch(guideAddonsDataloaded(undefined));
      return;
    }

    void get({ url: '/conservatory/getaddondata?productId=' + productId })
      .then(response => {
        if (response.status !== RESPONSESTATUS_SUCCESS) {
          dispatch(guideAddonsDataloaded(undefined));
          return;
        }

        return response.json();
      })
      .then((data: ConservatoryAddonProductModel[]) => {
        dispatch(guideAddonsDataloaded(data));
      });
  };
};
